import React from 'react';
import ReactDOM from 'react-dom/client';
import '@pokefolio/ui/styles';
import './index.css';
import './styles/theme.css';
import { App } from './App';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
